import { SIDE_COLORS, WARRIOR_SCALE } from '@halvard/board3d';
import type { ice } from '@halvard/rules';

/** A flat warrior: cloak, helmet and, except for the Skier, a round shield. Size shows force. */
export function WarriorGlyph({
  side,
  type,
  size = 40,
}: {
  side: ice.Side;
  type: ice.WarriorType;
  size?: number;
}) {
  const { body, trim } = SIDE_COLORS[side];
  const k = WARRIOR_SCALE[type] / WARRIOR_SCALE.huscarl;
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
      <g transform={`translate(20 38) scale(${k}) translate(-20 -38)`}>
        <path d="M13 38 L16 18 H24 L27 38 Z" fill={body} />
        <rect x="14" y="17" width="12" height="3" rx="1.5" fill={trim} />
        <circle cx="20" cy="12" r="5" fill="#E2C4A6" />
        <path d="M14.6 11 A5.4 5.4 0 0 1 25.4 11 Z" fill="#9AA3AB" />
        {type === 'skier' ? (
          <rect x="8" y="37" width="24" height="2" rx="1" fill="#7A5634" />
        ) : (
          <circle
            cx="12"
            cy="26"
            r={type === 'huscarl' ? 8 : 6.5}
            fill={trim}
            stroke="#9AA3AB"
            strokeWidth="1.2"
          />
        )}
        {type === 'spear' && <path d="M29 36 V8 L30.5 4 L32 8 V36 Z" fill="#7A5634" />}
      </g>
    </svg>
  );
}
